/* tslint:disable */
/* eslint-disable */

/**
 * Sync status of this document link
 */
export enum WorkDocumentSyncStatusEnum {
  Pending = 'pending',
  Syncing = 'syncing',
  Synced = 'synced',
  Failed = 'failed',
  Conflict = 'conflict'
}
